import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import BackupSvg from '../../../assets/icons/nav/backup.svg?raw';

export const BackupIcon = (props) => <CustomSVG svg={BackupSvg} preserveColors {...props} />;
